<template>
    <v-container v-html="textForPrint">
    </v-container>
</template>

<script>

export default {
  name: "PrintData",
  data() {
    return {
      textForPrint: ''
    }
  },
  methods: {
    init() {
      this.textForPrint = this.$route.query.data
      window.print();
      setTimeout(function () { window.close(); }, 1000);
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

strong {
  font-family: "THSarabunNew";
  font-weight: bold;
  color: black;
}

p {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

ul {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

ol {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

i {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

s {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}
</style>